import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from 'src/config/config';
import { apiConstants } from "../constant/apiConstant";
import { map } from 'rxjs';
import { commonFunctionService } from '../utils/commonFunctions';

@Injectable({
    providedIn: 'root'
})
export class EventCategoryService {

    constructor(private http: HttpClient, private commonFunctionService: commonFunctionService) { }

    schoolData = localStorage.getItem('schoolAllInfo');
    parsedData = JSON.parse(this.schoolData);
    academicId = this.parsedData?.currentAcademicId;
    private URL_V3 = AppSettings.API_ENDPOINT_V3;
    private language = "en";
    private params = new HttpParams().set("lang", this.language).set("academicId", this.academicId);

    getColorListAPI() {
        return this.http
            .get(this.URL_V3 + apiConstants.getColorListApiEndpoint, {
                headers: this.commonFunctionService.appendHeader(),
                params: this.params,
            })
            .pipe(map((res) => res));
    }

    createEventCategory(body: any) {
        const headers = this.commonFunctionService.appendHeader();
        const url = this.URL_V3 + apiConstants.createEventCategoryApiEndpoint;
        return this.http.post(url, body, { headers }).pipe(map((res) => res));
    }

    getEventCategory() {
        return this.http
            .get(this.URL_V3 + apiConstants.getEventCategoryApiEndpoint, {
                headers: this.commonFunctionService.appendHeader(),
                params: this.params
            })
            .pipe(map((res) => res));
    }

    editEventCategory(body: any) {
        const headers = this.commonFunctionService.appendHeader();
        const url = this.URL_V3 + apiConstants.editEventCategoryApiEndpoint;
        return this.http.put(url, body, { headers }).pipe(map((res) => res));
    }

    deleteEventCategory(body: any) {
        const headers = this.commonFunctionService.appendHeader();
        const url = this.URL_V3 + apiConstants.deleteEventCategoryApiEndpoint;
        return this.http.delete(url, { body, headers }).pipe(map((res) => res));
    }
}
